import { EventEmitter } from 'eventemitter3';

export type ApplicationEvent = {
  type: string;
}

export class EventBus {
  private eventEmitter: EventEmitter = new EventEmitter();

  addListener<T extends ApplicationEvent>(eventType: string, listener: (event: T) => any): () => void {
    this.eventEmitter.addListener(eventType, listener);
    return () => {
      this.eventEmitter.removeListener(eventType, listener);
    }
  }

  removeListener<T extends ApplicationEvent>(eventType: string, listener: (event: T) => any) {
    this.eventEmitter.removeListener(eventType, listener);
  }

  clearListeners(eventType: string) {
    this.eventEmitter.removeAllListeners(eventType);
  }

  notify<T extends ApplicationEvent>(event: T) {
    this.eventEmitter.emit(event.type, event);
  }
}

export const appEventBus = new EventBus();
